"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.values");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'alink',
  components: {},
  data: function data() {
    return {
      list: [],
      clickSubmit: false,
      editDialog: false,
      editObj: {}
    };
  },
  computed: {},
  mounted: function mounted() {
    this.getConfig();
  },
  methods: {
    /**
     * 获取配置
     */
    getConfig: function getConfig() {
      var _this = this;
      this.$get('WxOpen/getConfigs').then(function (res) {
        _this.list = Object.values(res);
      });
    },
    /**
     * 提交修改
     */
    postEdit: function postEdit() {
      var _this2 = this;
      if (this.clickSubmit) return;
      this.clickSubmit = false;
      this.$post('WxOpen/editConfig', this.editObj).then(function (res) {
        _this2.editDialog = false;
        _this2.getConfig();
        _this2.$message({
          message: '修改成功',
          type: 'success'
        });
        _this2.clickSubmit = false;
      });
    }
  }
};